import { render, staticRenderFns } from "./AppExpansionPanelContent.vue?vue&type=template&id=dbfdfa0a&"
import script from "./AppExpansionPanelContent.vue?vue&type=script&lang=ts&"
export * from "./AppExpansionPanelContent.vue?vue&type=script&lang=ts&"
import style0 from "./AppExpansionPanelContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanelContent})
